<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
>
  <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div>
  <!-- <div fxFlex="10%">{{workflow?.workflowGroupName}}</div> -->
  <div fxFlex="28%">{{ workflow?.workflowGroupDescription }}</div>
  <div fxFlex="15%">
    {{
      removeUnderScore(workflow?.jpaWorkflowGroupViewPK.workflowType)
        | uppercase
    }}
  </div>
  <div fxFlex="10%">
    <a
      style="border-radius: 10px"
      class="ui tiny label"
      [ngClass]="{
        green: workflow.active == true,
        red: workflow.active == false
      }"
    >
      {{ workflow?.active ? "ACTIVE" : "INACTIVE" }}
    </a>
  </div>
  <div fxFlex="15%">{{ name }}</div>
  <div fxFlex="15%">{{ workflow?.dateCreated | date: "MMM d, y h:mm a" }}</div>
  <div fxFlex="15%" class="text-right">
    <div
      style="height: fit-content; padding: 10px 15px"
      class="ui primary mini basic dropdown button"
      suiDropdown
    >
      <div class="text">Actions</div>
      <i class="dropdown icon"></i>
      <div class="left menu primary" suiDropdownMenu>
        <div
          class="item green"
          *ngIf="!workflow.active"
          (click)="activateWorkflow.emit(workflow)"
        >
          Activate Workflow
        </div>
        <div
          class="item red"
          *ngIf="workflow.active"
          (click)="deActivateWorkflow.emit(workflow)"
        >
          De Activate Workflow
        </div>
        <div class="item primary" (click)="updateWorkflow.emit(workflow)">
          Update Workflow
        </div>
        <div class="item primary" (click)="viewWorkflow(workflow)">
          View Groups
        </div>
      </div>
    </div>
  </div>
</div>
